import { useState, useEffect } from "react";
import ProductCard from "./product-card";
import { ChevronLeft, ChevronRight } from "lucide-react";
import PremiumStand from '../../assets/goods/flash-sales/premium-stand-mixer.webp';
import Smart_Air_Fryer from '../../assets/goods/flash-sales/premium-air-fryer.webp';
import Cordless_Drill from '../../assets/goods/flash-sales/premium-cordless.webp';
import Portable_ac from '../../assets/goods/flash-sales/premium-portable-ac.webp';

// Sample Data
const flashSaleProducts = [
  {
    id: "1",
    name: "Premium Stand Mixer",
    image: PremiumStand,
    price: 159.99,
    originalPrice: 220.0,
    rating: 4.5,
    reviewCount: 3654,
    discount: 25,
  },
  {
    id: "2",
    name: "Smart Air Fryer",
    image: Smart_Air_Fryer,
    price: 89.99,
    originalPrice: 129.99,
    rating: 4.7,
    reviewCount: 1254,
    discount: 30,
  },
  {
    id: "3",
    name: "Cordless Power Drill",
    image: Cordless_Drill,
    price: 69.99,
    originalPrice: 99.99,
    rating: 4.8,
    reviewCount: 2345,
    discount: 30,
  },
  {
    id: "4",
    name: "Portable AC Unit",
    image: Portable_ac,
    price: 249.99,
    originalPrice: 329.99,
    rating: 4.2,
    reviewCount: 567,
    discount: 25,
  },
];

export default function FlashSales() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 3);

    const updateTimer = () => {
      const now = new Date();
      const difference = endDate.getTime() - now.getTime();

      if (difference <= 0) {
        clearInterval(timer);
        return;
      }

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000),
      });
    };

    const timer = setInterval(updateTimer, 1000);
    updateTimer();

    return () => clearInterval(timer); // Cleanup interval on unmount
  }, []);

  return (
    <section className="my-12">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl md:text-2xl font-bold flex items-center text-gray-800">
          <span className="w-1 h-6 bg-[#ff9906] mr-2 inline-block"></span>
          Flash Sales
        </h2>
        <div className="flex items-center space-x-4">
          {/* Countdown Timer */}
          <div className="hidden md:flex items-center space-x-2">
            {["days", "hours", "minutes", "seconds"].map((key, index) => (
              <div key={index} className="flex flex-col items-center bg-white border rounded-md w-14 h-16 shadow-sm p-2">
                <span className="text-xl font-bold text-gray-800">
                  {timeLeft[key]?.toString().padStart(2, "0")}
                </span>
                <span className="text-xs text-gray-500">{key.charAt(0).toUpperCase() + key.slice(1)}</span>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex space-x-2">
            <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
              <ChevronLeft size={20} />
            </button>
            <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {flashSaleProducts.map((product) => (
          <ProductCard key={product.id} {...product} />
        ))}
      </div>

      {/* View All Button */}
      <div className="flex justify-center mt-8">
        <button className="border border-[#ff9906] text-[#ff9906] px-4 py-2 rounded-md hover:bg-[#ff9906] hover:text-white transition-colors">
          View All Products
        </button>
      </div>
    </section>
  );
}
